"use client";
import { SPACINGS as S } from "../../tokens/spacings/Spacings.js";
const m = {
  padding: S.xxs
}, e = {
  md: "2.75rem",
  sm: "2rem"
};
export {
  e as SELECT_ITEM_SIZES,
  m as SELECT_LIST_SIZES
};
